import { BaseVirtualizedTable } from "./BaseVirtualizedTable"
import { BasicTableProps } from "./types"

export function BasicTanStackTable<TData>({
  data,
  columnDefinitions,
  getRowProps,
  sortingState,
  tableContainerProps,
  defaultColumnVisibility,
  isLoading,
  id,
  tableOptions,
  withSettingsMenu,
}: BasicTableProps<TData>) {
  return (
    <BaseVirtualizedTable
      id={id}
      data={data}
      columnDefinitions={columnDefinitions}
      getRowProps={getRowProps}
      sortingState={sortingState}
      tableContainerProps={tableContainerProps}
      defaultColumnVisibility={defaultColumnVisibility}
      isLoading={isLoading}
      tableOptions={tableOptions}
      withSettingsMenu={withSettingsMenu}
    />
  )
}
